module.exports = __webpack_public_path__ + "static/media/review-art.9df4c42b.png";